import { PersistentResource, SyncWriteResponse } from "../types"
import { applyMinimalChangesToArray } from "./array";


export const applyWriteResponsesToArray = <T extends PersistentResource<I>, I>(currentResources: T[], writeResponses: SyncWriteResponse<T, I>[]) => {
    const resourcesAfterWrites = writeResponses.map((wr) => wr.resourceAfterWrite).filter((resource) => !!resource);
    const newlyCreatedIds = writeResponses.filter((wr) => !wr.resourceBeforeWrite).map((wr) => wr.resourceAfterWrite?.id);
    const otherIds = writeResponses.map((wr) => wr.request.id).filter((id) => !!id);
    const allIds = [ ...newlyCreatedIds, ...otherIds ];
    const allIdsSet = new Set(allIds);
    return applyMinimalChangesToArray(currentResources, resourcesAfterWrites, (resource) => allIdsSet.has(resource?.id));
}